import { render, staticRenderFns } from "./NewCall.vue?vue&type=template&id=1516226b&"
import script from "./NewCall.vue?vue&type=script&lang=js&"
export * from "./NewCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports